var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex position-relative pt-24 activity-page-hero-row",
      class: _vm.type
    },
    [
      _c("div", { ref: "hero", staticClass: "hero h-100" }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "contentContainer", staticClass: "container" },
        [
          _vm.activity.acf.content.heading === "left_aligned"
            ? _c("div", { staticClass: "row mb-40 mb-lg-80 pt-md-40" }, [
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("h2", {
                    staticClass: "text-white mb-16",
                    domProps: { innerHTML: _vm._s(_vm.activity.title.rendered) }
                  }),
                  _vm._v(" "),
                  _vm.activity.acf &&
                  _vm.activity.acf.content &&
                  _vm.activity.acf.content.introduction &&
                  _vm.activity.acf.content.introduction.bullet_points
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "text-white font-weight-light mb-40 mb-lg-0"
                        },
                        _vm._l(
                          _vm.activity.acf.content.introduction.bullet_points,
                          function(intro, key) {
                            return _c(
                              "span",
                              { key: key, staticClass: "d-block intro-line" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(intro.bullet_point) +
                                    "\n                    "
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _vm.relevantSubcategories
                    ? _c(
                        "div",
                        { staticClass: "tag-row tag-row-lg mt-lg-16" },
                        _vm._l(_vm.relevantSubcategories, function(category) {
                          return _c(
                            "div",
                            { key: category.id, staticClass: "tag-col" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.route("nl.activities", {
                                      categories: category.slug
                                    })
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "tag tag-accent tag-sm",
                                    domProps: {
                                      innerHTML: _vm._s(category.name)
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.location
                    ? _c("div", { staticClass: "location mt-40 mt-lg-16" }, [
                        _c("span", {
                          staticClass: "text-white font-weight-light",
                          domProps: { innerHTML: _vm._s(_vm.location.name) }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupSize
                    ? _c("div", { staticClass: "group-size mt-16" }, [
                        _c("span", {
                          staticClass: "text-white font-weight-light",
                          domProps: { innerHTML: _vm._s(_vm.groupSize.name) }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duration
                    ? _c("div", { staticClass: "duration mt-16" }, [
                        _c("span", {
                          staticClass: "text-white font-weight-light",
                          domProps: { innerHTML: _vm._s(_vm.duration.name) }
                        })
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activity.acf.content.heading === "centered"
            ? _c("div", { staticClass: "row mb-40 mb-md-80 pt-md-40" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 text-md-center align-items-md-center d-flex flex-column"
                  },
                  [
                    _vm.relevantSubcategories
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "tag-row tag-row-lg mb-24 order-2 order-md-0"
                          },
                          _vm._l(_vm.relevantSubcategories, function(category) {
                            return _c(
                              "div",
                              { key: category.id, staticClass: "tag-col" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.route("nl.activities", {
                                        categories: category.slug
                                      })
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "tag tag-accent tag-sm",
                                      domProps: {
                                        innerHTML: _vm._s(category.name)
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h2", {
                      staticClass: "text-white mb-16 order-0 order-md-1",
                      domProps: {
                        innerHTML: _vm._s(_vm.activity.title.rendered)
                      }
                    }),
                    _vm._v(" "),
                    _vm.activity.acf &&
                    _vm.activity.acf.content &&
                    _vm.activity.acf.content.introduction &&
                    _vm.activity.acf.content.introduction.bullet_points
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "order-1 order-md-2 text-white font-weight-light mb-40"
                          },
                          _vm._l(
                            _vm.activity.acf.content.introduction.bullet_points,
                            function(intro, key) {
                              return _c(
                                "span",
                                {
                                  key: key,
                                  staticClass: "d-block d-md-inline"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(intro.bullet_point) +
                                      " "
                                  ),
                                  key < 2
                                    ? _c("span", { staticClass: "divider" }, [
                                        _vm._v("|")
                                      ])
                                    : _vm._e()
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column flex-md-row order-4 order-md-3"
                      },
                      [
                        _vm.location
                          ? _c(
                              "div",
                              { staticClass: "location mt-16 mr-md-40" },
                              [
                                _c("span", {
                                  staticClass: "text-white font-weight-light",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.location.name)
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.groupSize
                          ? _c(
                              "div",
                              { staticClass: "group-size mt-16 mr-md-40" },
                              [
                                _c("span", {
                                  staticClass: "text-white font-weight-light",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.groupSize.name)
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.duration
                          ? _c("div", { staticClass: "duration mt-16" }, [
                              _c("span", {
                                staticClass: "text-white font-weight-light",
                                domProps: {
                                  innerHTML: _vm._s(_vm.duration.name)
                                }
                              })
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "template_1_images"
            ? [
                _c(
                  "div",
                  { staticClass: "position-relative" },
                  [
                    _c("img", {
                      ref: "primary",
                      staticClass: "w-100 h-100",
                      attrs: {
                        src: _vm.activity.acf.content.images[0].url,
                        alt: _vm.activity.title.rendered
                      }
                    }),
                    _vm._v(" "),
                    _vm.activity.acf.content.video_id != null &&
                    _vm.activity.acf.content.video_id != ""
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "video-wrapper",
                              class: { loaded: _vm.heroLoaded }
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "plyr",
                                  staticClass: "plyr__video-embed",
                                  attrs: { id: "player" }
                                },
                                [
                                  _c("iframe", {
                                    attrs: {
                                      src:
                                        "https://player.vimeo.com/video/" +
                                        _vm.activity.acf.content.video_id +
                                        "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                                      allowfullscreen: "",
                                      allowtransparency: "",
                                      allow: "autoplay"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm.type === "template_2_images"
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-block d-md-flex flex-column flex-md-row images"
                  },
                  [
                    _c("img", {
                      staticClass: "first mb-24 mb-md-0",
                      attrs: {
                        src: _vm.activity.acf.content.images[0].url,
                        alt: _vm.activity.title.rendered
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "second position-relative" },
                      [
                        _c("img", {
                          ref: "primary",
                          staticClass: "w-100 h-100",
                          attrs: {
                            src: _vm.activity.acf.content.images[1].url,
                            alt: _vm.activity.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        _vm.activity.acf.content.video_id != null &&
                        _vm.activity.acf.content.video_id != ""
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "video-wrapper",
                                  class: { loaded: _vm.heroLoaded }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "plyr",
                                      staticClass: "plyr__video-embed",
                                      attrs: { id: "player" }
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src:
                                            "https://player.vimeo.com/video/" +
                                            _vm.activity.acf.content.video_id +
                                            "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                                          allowfullscreen: "",
                                          allowtransparency: "",
                                          allow: "autoplay"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ]
            : _vm.type === "template_3_images"
            ? [
                _c(
                  "div",
                  { staticClass: "d-block d-lg-flex flex-wrap images" },
                  [
                    _c(
                      "div",
                      { staticClass: "first position-relative mb-24 mb-lg-0" },
                      [
                        _c("img", {
                          ref: "primary",
                          staticClass: "w-100 h-100",
                          attrs: {
                            src: _vm.activity.acf.content.images[0].sizes.large,
                            alt: _vm.activity.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        _vm.activity.acf.content.video_id != null &&
                        _vm.activity.acf.content.video_id != ""
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "video-wrapper",
                                  class: { loaded: _vm.heroLoaded }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "plyr",
                                      staticClass: "plyr__video-embed",
                                      attrs: { id: "player" }
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src:
                                            "https://player.vimeo.com/video/" +
                                            _vm.activity.acf.content.video_id +
                                            "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                                          allowfullscreen: "",
                                          allowtransparency: "",
                                          allow: "autoplay"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "second-third d-flex flex-column flex-md-row flex-lg-column"
                      },
                      [
                        _c("div", { staticClass: "d-block d-lg-flex" }, [
                          _c("img", {
                            staticClass: "second mb-24 mb-md-0 mb-lg-24",
                            attrs: {
                              src:
                                _vm.activity.acf.content.images[1].sizes.large,
                              alt: _vm.activity.title.rendered
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-block d-lg-flex" }, [
                          _c("img", {
                            staticClass: "third",
                            attrs: {
                              src:
                                _vm.activity.acf.content.images[2].sizes.large,
                              alt: _vm.activity.title.rendered
                            }
                          })
                        ])
                      ]
                    )
                  ]
                )
              ]
            : _vm.type === "template_4_images"
            ? [
                _c(
                  "div",
                  { staticClass: "d-block d-md-flex flex-wrap images" },
                  [
                    _c(
                      "div",
                      { staticClass: "first position-relative mb-24 mb-md-0" },
                      [
                        _c("img", {
                          ref: "primary",
                          staticClass: "w-100 h-100",
                          attrs: {
                            src: _vm.activity.acf.content.images[0].sizes.large,
                            alt: _vm.activity.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        _vm.activity.acf.content.video_id != null &&
                        _vm.activity.acf.content.video_id != ""
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "video-wrapper",
                                  class: { loaded: _vm.heroLoaded }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "plyr",
                                      staticClass: "plyr__video-embed",
                                      attrs: { id: "player" }
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src:
                                            "https://player.vimeo.com/video/" +
                                            _vm.activity.acf.content.video_id +
                                            "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                                          allowfullscreen: "",
                                          allowtransparency: "",
                                          allow: "autoplay"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-block d-md-flex flex-column right-col h-100"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-block d-md-flex flex-column flex-md-row w-100 h-50 pb-24"
                          },
                          [
                            _c("img", {
                              staticClass: "second mb-24 mb-md-0",
                              attrs: {
                                src:
                                  _vm.activity.acf.content.images[1].sizes
                                    .large,
                                alt: _vm.activity.title.rendered
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "third",
                              attrs: {
                                src:
                                  _vm.activity.acf.content.images[2].sizes
                                    .large,
                                alt: _vm.activity.title.rendered
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fourth",
                          attrs: {
                            src: _vm.activity.acf.content.images[3].sizes.large,
                            alt: _vm.activity.title.rendered
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "template_custom"
            ? [
                _c(
                  "div",
                  { staticClass: "row images" },
                  _vm._l(_vm.activity.acf.content.images.slice(0, 4), function(
                    image,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: image.id,
                        staticClass: "col-12 col-lg-3 mb-16 mb-lg-0 h-100"
                      },
                      [
                        _c("img", {
                          ref: "customimage",
                          refInFor: true,
                          staticClass: "w-100 h-100",
                          attrs: {
                            src: image.url,
                            alt: _vm.activity.title.rendered
                          }
                        }),
                        _vm._v(" "),
                        index == 0 &&
                        _vm.activity.acf.content.video_id != null &&
                        _vm.activity.acf.content.video_id != ""
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "video-wrapper",
                                  class: { loaded: _vm.heroLoaded }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "plyr",
                                      refInFor: true,
                                      staticClass: "plyr__video-embed",
                                      attrs: { id: "player" }
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src:
                                            "https://player.vimeo.com/video/" +
                                            _vm.activity.acf.content.video_id +
                                            "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                                          allowfullscreen: "",
                                          allowtransparency: "",
                                          allow: "autoplay"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }